import moment, { Moment } from "moment";

export interface MembershipDto {
  region: string;
  membershipNumber: string;
  firstName: string;
  lastName: string;
  endedAt: string;
}

export class Membership {
  region: string;
  number: string;
  firstName: string;
  lastName: string;
  updatedAt: Moment;
  endedAt: Moment;

  constructor(dto: MembershipDto) {
    this.region = dto.region;
    this.number = dto.membershipNumber;
    this.firstName = dto.firstName;
    this.lastName = dto.lastName;
    this.updatedAt = moment();
    this.endedAt = moment(dto.endedAt);
  }
}
